import { render, staticRenderFns } from "./SampleReceivedBar.vue?vue&type=template&id=55c6a9c2"
import script from "./SampleReceivedBar.vue?vue&type=script&lang=js"
export * from "./SampleReceivedBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports